import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=3a86191f"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a86191f')) {
      api.createRecord('3a86191f', component.options)
    } else {
      api.reload('3a86191f', component.options)
    }
    module.hot.accept("./NotFound.vue?vue&type=template&id=3a86191f", function () {
      api.rerender('3a86191f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NotFound.vue"
export default component.exports